import usageTracker from 'unsubscribe-ui/utils/tracking/usageTracker';
import { APP_NAME } from 'unsubscribe-ui/utils/tracking/trackingUtils';
import Raven from 'raven-js';
import { getPageLangLocale } from 'unsubscribe-ui/utils/language';
export const trackInteraction = ({
  screen,
  module,
  action
}) => {
  try {
    usageTracker.track('Subscriptions', 'Subscriptions Interaction', {
      appName: APP_NAME,
      screen,
      module,
      action,
      language: getPageLangLocale(window.location.pathname)
    });
  } catch (error) {
    Raven.captureException(error, {
      extra: {
        location: 'unsubscribe-ui/utils/trackingEvents'
      }
    });
  }
};
export const trackUsage = ({
  screen,
  module,
  action
}) => {
  try {
    usageTracker.track('Subscriptions', 'Subscriptions Usage', {
      appName: APP_NAME,
      module,
      screen,
      action,
      language: getPageLangLocale(window.location.pathname)
    });
  } catch (error) {
    Raven.captureException(error, {
      extra: {
        location: 'unsubscribe-ui/utils/trackingEvents'
      }
    });
  }
};
export const trackView = ({
  screen,
  module
}) => {
  try {
    usageTracker.track('Subscriptions', 'Subscriptions View', {
      appName: APP_NAME,
      module,
      screen,
      language: getPageLangLocale(window.location.pathname)
    });
  } catch (error) {
    Raven.captureException(error, {
      extra: {
        location: 'unsubscribe-ui/utils/trackingEvents'
      }
    });
  }
};